const $inject = ['$q', '$http', '$httpParamSerializer', 'moment'];

const authService = function ($q, $http, $httpParamSerializer, moment) {
  const service = {
    prevRoute: undefined,
    getUsername,
    login,
    logout,
    getOauth,
    getAccessToken,
    getRefreshToken,
    isAuthenticated,
    getFullname,
    getInitials
  };

  let CLIENT_ID = '40cd37d4-267a-43ca-99d3-f5bd67b8e58d';

  function getUsername() {
    if (!service.getOauth()) return;

    return service.getOauth().username;
  }

  function getFullname() {
    if (!service.getOauth()) return;

    return service.getOauth().fullname;
  }

  function getInitials() {
    var fullname = getFullname();
    if(fullname === null ||fullname === undefined) return '--';
    
    var words = fullname.split(' ');
    return words.map((word) => {
      return word[0];
    }).join('');
  }

  function login(username, password) {
    let deferred = $q.defer();

    let data = {
      client_id: CLIENT_ID,
      grant_type: 'password',
      username: username,
      password: password
    };

    let req = {
      method: 'POST',
      url: `${endPointUrl}/Token`,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded; charset=utf-8'
      },
      data: $httpParamSerializer(data)
    };

    $http(req).then(function (data) {
      let oauth = data.data;
      oauth.expires_at = moment().add(oauth.expires_in, 's').format('x');
      oauth.username = username;

      localStorage.setItem('oauth', JSON.stringify(oauth));
      deferred.resolve(oauth);
    });

    return deferred.promise;
  }

  function logout() {
    setTimeout(() => {
      if (localStorage.getItem('oauth')) {
        window.location.reload(); // 🤮
      } else {
        localStorage.removeItem('oauth');
      }
      try {
        window.auth0Client.logout({logoutParams: {returnTo: window.location.origin}});
      } catch (error) {
        console.error(error);
      }
    }, 1000);
  }

  function getOauth() {
    return JSON.parse(localStorage.getItem('oauth'));
  }

  function getAccessToken() {
    var oauth = service.getOauth();

    return oauth ? oauth.access_token : '';
  }

  function getRefreshToken() {
    var oauth = service.getOauth();

    return oauth ? oauth.refresh_token : '';
  }

  function isAuthenticated() {
    var oauth = service.getOauth();
    if (oauth && oauth.from && oauth.from === 'auth0') {
      return true;
    } else {
      return oauth && oauth.expires_at && oauth.expires_at > Date.now();
    }
  }

  return service;
};

authService.$inject = $inject;

export default authService;



// WEBPACK FOOTER //
// ./src/services/authService.js